<section class="mx-3">
  <div class="hdrpadding d-flex justify-content-between align-items-center">
    <div>
      <h2 class="m-0"><span translate>Course</span> - {{course}}</h2>
    </div>

    <form [formGroup]="form" class="form" style="width: 30%;">
      <div class="row">
        <div *ngFor="let question of questions">
          <app-question [question]="question" [form]="form"></app-question>
        </div>
      </div>
    </form>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z1">

      <ng-container matColumnDef="slno">
        <th mat-header-cell *matHeaderCellDef translate>Sl. no</th>
        <td mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="subjects">
        <th mat-header-cell *matHeaderCellDef translate>Subjects</th>
        <td mat-cell *matCellDef="let element">{{ element.subject_name }}</td>
      </ng-container>

      <ng-container matColumnDef="subject_id">
        <th mat-header-cell *matHeaderCellDef translate>Subjects Id</th>
        <td mat-cell *matCellDef="let element">
          {{ element.subject_id }}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          <div style="float: right;padding: 0% 11%;" translate>Actions</div>
        </th>
        <td mat-cell *matCellDef="let element">
          <div style="flex-direction: row;display: flex;justify-content: flex-end">
            <button matButton class="viewBtn" style="margin-top:2%;"
              (click)="viewESubjectData(element.subject_id,element.subject_name)">
              <span translate>View</span>
            </button>
          </div>
        </td>
      </ng-container>

      <!-- Header and Row Definitions -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
<div class="mt-2" *ngIf="total_count >= 1">
    <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
  </div>
</section>